import React from 'react';
import {
    canRunAds,
    canRunAdsFirefox,
    ConfigProvider,
    CookieCompliance,
    CookieComplianceCategories,
    DeviceType,
    getDevice,
    I18nProvider,
} from '@deporvillage/utils-library-component';
import { UserTemplate } from '@deporvillage/frontend-common';
import MessageData from '@deporvillage/frontend-common/src/context/message/context';
import CartData from '@deporvillage/frontend-common/src/context/cart/context';
import LoaderData from '@deporvillage/frontend-common/src/context/loader/context';

const DefaultMobileThreshold = 1035;

// TODO: FF to be removed #CTLG-740
const EnableEeTrackingEvents = false;

const ConfigTemplate = ({ children, config, i18n = {} }) => {
    const [width, setWidth] = React.useState(null);
    const [device, setDevice] = React.useState(DeviceType.Mobile);
    const [isMobile, setIsMobile] = React.useState(true);

    const [allowedCookies, setAllowedCookies] = React.useState(false);
    const [isOptanonInited, setIsOptanonInited] = React.useState(false);
    const [isNotPrivateOrStrict, setIsNotPrivateOrStrict] = React.useState(false);

    const handleUpdateDimensions = () => {
        const width = window.innerWidth;
        setWidth(width);
        setIsMobile(width < DefaultMobileThreshold);
        setDevice(getDevice(width));
    };

    // istanbul ignore next
    const handleOnOptanonResolve = (allowedCookies) => {
        setAllowedCookies(allowedCookies);
        setIsOptanonInited(true);
    };

    const handleOptanon = async () => {
        CookieCompliance(handleOnOptanonResolve, CookieComplianceCategories.Targeting);
        const canRunFx = await canRunAdsFirefox();
        setIsNotPrivateOrStrict(canRunFx);
    };

    React.useEffect(() => {
        handleOptanon();
        handleUpdateDimensions();
        window.addEventListener('resize', handleUpdateDimensions);
        return () => {
            window.removeEventListener('resize', handleUpdateDimensions);
        };
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, []);

    return (
        <ConfigProvider config={{
            ...config,
            width,
            isMobile,
            device,
            canRunAds: (
                /* istanbul ignore next */
                canRunAds() && isNotPrivateOrStrict && allowedCookies
            ),
            isOptanonInited,
            // TODO: FF to be removed #CTLG-740
            isEeTrackingEnabled: EnableEeTrackingEvents,
        }}>
            <I18nProvider translations={i18n}>
                <CartData>
                    <MessageData>
                        <LoaderData>
                            <UserTemplate>
                                {
                                    children
                                }
                            </UserTemplate>
                        </LoaderData>
                    </MessageData>
                </CartData>
            </I18nProvider>
        </ConfigProvider>
    );
};

export default ConfigTemplate;
